var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAirport(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "car_2_",
    "data-name": "car(2)",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6360",
    "data-name": "Rectangle 6360",
    width: 40,
    height: 38.786,
    fill: "#353841"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6355",
    "data-name": "Rectangle 6355",
    fill: "#f1f5ff",
    stroke: "#353841",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 72.5,
    height: 72.5,
    rx: 11.25,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_34968",
    "data-name": "Group 34968",
    transform: "translate(17 17.607)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_34962",
    "data-name": "Group 34962",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24458",
    "data-name": "Path 24458",
    d: "M0,31.406c1.214-1.25,2.416-2.51,3.647-3.743a2.22,2.22,0,0,1,1.66-.551q7.831.008,15.662,0h.482V23.794a1.7,1.7,0,0,1-1.383-1.529c-.456-1.989-.952-3.969-1.434-5.952a1.511,1.511,0,0,1,1.6-2.057c.755,0,1.51,0,2.265,0h.459c-.3-1.256-.59-2.454-.879-3.652-.2-.847-.412-1.692-.614-2.539A1.6,1.6,0,0,1,23.159,5.93q2.578,0,5.155,0h.463V4.59c-.225,0-.454.01-.682,0a.615.615,0,0,1-.645-.6.6.6,0,0,1,.633-.6q1.327-.021,2.656,0A.581.581,0,0,1,31.356,4a.6.6,0,0,1-.611.585c-.116.01-.234,0-.351,0s-.23.01-.367.017V5.93h.4q2.48,0,4.96,0A1.605,1.605,0,0,1,37.08,8.07q-.7,2.9-1.4,5.8c-.026.109-.043.221-.074.385h.734c.755,0,1.512-.024,2.264.019a1.436,1.436,0,0,1,1.361,1.762c-.52,2.214-1.063,4.423-1.607,6.632a1.507,1.507,0,0,1-1.184,1.115v.458q0,3.691,0,7.382a1.722,1.722,0,0,1-.034.425.588.588,0,0,1-1.147-.018,2.05,2.05,0,0,1-.029-.426q0-3.652,0-7.3v-.481H22.7v16.77H25.7c.006-.133.018-.27.018-.408,0-1.3,0-2.6,0-3.906a1.738,1.738,0,0,1,1.922-1.9c1.12,0,2.239,0,3.359,0a1.705,1.705,0,0,1,1.81,1.81c0,1.458,0,2.915,0,4.439h1.164c.391,0,.781,0,1.172,0,.572-.006.805-.233.807-.807,0-1.549,0-3.1,0-4.648,0-.117,0-.234,0-.351.012-.476.239-.753.612-.748s.6.283.6.761c0,1.679.009,3.359,0,5.038a1.845,1.845,0,0,1-1.938,1.942q-15.994,0-31.987,0a3.152,3.152,0,0,1-3.167-2.5A1.059,1.059,0,0,0,0,39.14V31.406m1.215.833c-.008.15-.02.277-.02.4q0,2.89,0,5.781a2.022,2.022,0,0,0,2.22,2.2q4.335,0,8.671,0H12.5V40.16c0-1.315,0-2.63,0-3.945a1.718,1.718,0,0,1,1.859-1.842q1.66,0,3.32,0a1.739,1.739,0,0,1,1.915,1.91c0,1.3,0,2.6,0,3.906V40.6h1.849v-8.36ZM29.267,14.254q2.362,0,4.723,0c.2,0,.359.006.423-.267.494-2.086,1.009-4.167,1.509-6.251.1-.428-.055-.618-.5-.618q-6.148,0-12.3,0c-.461,0-.606.195-.5.643.494,2.046,1,4.089,1.479,6.138.07.3.2.361.475.359,1.561-.01,3.123,0,4.684,0m.012,1.21q-4.51,0-9.021,0c-.48,0-.569.107-.461.553.491,2.034.99,4.066,1.472,6.1a.535.535,0,0,0,.623.474q7.166-.017,14.332-.009c.876,0,.9-.016,1.15-.858.018-.062.036-.125.051-.188Q38.083,18.771,38.74,16c.1-.432.013-.537-.441-.537q-4.51,0-9.021,0M2.007,30.847l.122.135H21.443V28.325H12.048c-2.251,0-4.5-.01-6.752.012a1.478,1.478,0,0,0-.892.28c-.826.712-1.6,1.481-2.4,2.229m16.377,9.76c0-1.468,0-2.9,0-4.328,0-.556-.165-.716-.724-.718q-1.6,0-3.2,0c-.6,0-.76.16-.761.767q0,1.952,0,3.9c0,.124.013.247.02.375Zm13.233,0c0-1.536.009-3.03-.006-4.524,0-.356-.231-.52-.644-.522q-1.679-.008-3.358,0c-.5,0-.672.176-.673.688q0,2.031,0,4.061a2.58,2.58,0,0,0,.035.3Z",
    transform: "translate(0 -3.024)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24459",
    "data-name": "Path 24459",
    d: "M10.272,5.912,7.87,3.778c-.617-.549-.551-.988.2-1.31.549-.236,1.089-.5,1.653-.694a1.322,1.322,0,0,1,.815-.018c1.283.462,2.553.962,3.822,1.463A.616.616,0,0,0,15,3.151c1.353-.9,2.723-1.778,4.076-2.68A2.42,2.42,0,0,1,21.832.392a6.783,6.783,0,0,1,1.323,1.076c.47.476.395.846-.167,1.2q-5.54,3.505-11.082,7.007a6.082,6.082,0,0,1-2.226,1.086,4,4,0,0,1-3.308-.79C5.905,9.6,5.449,9.209,5,8.813c-.423-.372-.366-.734.053-1.1a2.243,2.243,0,0,1,2.295-.545A1.928,1.928,0,0,0,9.67,6.474a5.065,5.065,0,0,1,.6-.562M9.194,3.346c.749.666,1.489,1.32,2.225,1.978.458.41.456.76,0,1.174-.655.595-1.3,1.2-1.976,1.772a1.118,1.118,0,0,1-.691.262c-.556-.021-1.108-.125-1.662-.2l-.739-.095-.033.113c.2.175.407.352.613.526a2.869,2.869,0,0,0,3.6.247L20.225,3c.555-.351,1.109-.7,1.67-1.061a1.591,1.591,0,0,0-2.3-.369q-2.161,1.4-4.3,2.833a.919.919,0,0,1-.946.1c-1.133-.456-2.293-.847-3.409-1.338a1.594,1.594,0,0,0-1.745.185",
    transform: "translate(-4.218 0)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24460",
    "data-name": "Path 24460",
    d: "M57.226,102.381a1.814,1.814,0,0,1-.377.419q-2.853,1.832-5.725,3.636a.611.611,0,0,1-.914-.157.6.6,0,0,1,.278-.856q2.7-1.716,5.4-3.425a3.983,3.983,0,0,1,.5-.3c.411-.182.858.119.84.684",
    transform: "translate(-44.891 -91.036)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24461",
    "data-name": "Path 24461",
    d: "M250.081,213.011c-.936,0-1.872,0-2.807,0-.471,0-.753-.234-.75-.6s.271-.588.722-.59q2.827-.007,5.654,0c.449,0,.711.237.707.6s-.272.591-.718.593c-.936,0-1.872,0-2.807,0",
    transform: "translate(-220.796 -189.708)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24462",
    "data-name": "Path 24462",
    d: "M31.532,171.265c-.133-.131-.352-.264-.444-.457a.529.529,0,0,1,.258-.7c.628-.39,1.259-.777,1.89-1.164.221-.136.437-.283.666-.4a.585.585,0,0,1,.789.19.565.565,0,0,1-.146.8c-.874.559-1.764,1.094-2.652,1.633a1.861,1.861,0,0,1-.362.1",
    transform: "translate(-27.796 -150.883)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24463",
    "data-name": "Path 24463",
    d: "M34.852,301.557c-.922,0-1.845,0-2.767,0-.485,0-.743-.217-.737-.6s.265-.584.757-.585q2.786,0,5.573,0c.48,0,.744.221.738.6s-.258.581-.719.582c-.948,0-1.9,0-2.845,0",
    transform: "translate(-28.076 -269.02)",
    fill: "#353841"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24464",
    "data-name": "Path 24464",
    d: "M231.516,133.607h4.956c.712,0,.884.168.886.863,0,.832,0,1.665,0,2.5,0,.544-.21.75-.762.75q-5.092,0-10.184,0c-.542,0-.749-.212-.753-.764q-.01-1.288,0-2.575c0-.57.209-.769.787-.77q2.536,0,5.073,0m-4.635,2.873h9.251v-1.642h-9.251Z",
    transform: "translate(-202.102 -119.663)",
    fill: "#353841"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirport);
export default __webpack_public_path__ + "static/media/airport.582b7b2a0a21bdea3580869422b72a31.svg";
export { ForwardRef as ReactComponent };